import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

const FILENAME_RULE_TYPES = ["Dynamic", "Constant"];

export const ADVANCED_FILENAME_RULE_TYPES = [
  "Dynamic",
  "Constant",
  "Scoped",
  "ScopedPrefix",
  "ScopedSuffix",
];

type SelectFilenameRuleTypeProps = {
  isAdvancedOptionsEnabled: boolean;
  isDisabled?: boolean;
};

export const SelectFilenameRuleType: React.FC<SelectFilenameRuleTypeProps> = ({
  isAdvancedOptionsEnabled,
  isDisabled,
}) => {
  const { t } = useTranslation();

  const types = isAdvancedOptionsEnabled
    ? ADVANCED_FILENAME_RULE_TYPES
    : FILENAME_RULE_TYPES;

  return (
    <SelectField
      name="type"
      label={t("inputFormats.actions.filenameRules.form.label.type")}
      style={{ width: "100%" }}
      options={types.map((typeId) => ({
        label: t(`inputFormats.actions.filenameRules.types.${typeId}`),
        value: typeId,
      }))}
      disabled={isDisabled}
    />
  );
};
